module.exports = __webpack_public_path__ + "media/Seher vor Rauch.821ff4a0.mp3";